import React from 'react'
import { AttackEventQuery } from './attack-event-query'
import { AttackEventOverviewView } from './attack-event-overview-view'

export interface AttackEventOverviewProps {
  readonly organizationID: string
  readonly attackEventID: string
}

/**
 * This is used directly as an angular to react bridge component
 */
export function AttackEventOverviewBridge({
  organizationID,
  attackEventID
}: AttackEventOverviewProps) {
  return (
    <AttackEventQuery
      organizationID={organizationID}
      attackEventID={attackEventID}
    >
      {({ attackEvent }) => {
        const {
          httpRequest,
          userInput,
          details,
          application,
          server,
          result,
          sourceIP,
          ruleUuid,
          detectionType,
          callLocation
        } = attackEvent
        return (
          <AttackEventOverviewView
            httpRequest={httpRequest}
            userInput={userInput}
            details={details}
            application={application}
            server={server}
            result={result}
            sourceIP={sourceIP}
            ruleUuid={ruleUuid}
            detectionType={detectionType}
            organizationID={organizationID}
            callLocation={callLocation}
          />
        )
      }}
    </AttackEventQuery>
  )
}
